import "./Table.css";
import { RiWhatsappFill } from "react-icons/ri";
const Table = ({ users }) => {
  return (
    <div class="table__container">
      <table>
        <thead>
          <tr>
            <th>Nom Complet</th>

            <th>Donneur/Bénéficier</th>
            <th>Téléphone</th>
          </tr>
        </thead>
        <tbody>
          {users.map(({ name, lastName, tel, donator }) => {
            return (
              <tr>
                <td>{`${name} ${lastName}`}</td>

                <td>{donator ? "Donneur" : "Bénéficier"}</td>
                <td
                  style={{
                    display: "flex",
                    gap: "0.7rem",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    alignItem: "center"
                  }}
                >
                  <a href={`tel:+212${tel.slice(1)}`}>{tel}</a>
                  <a
                    href={`https://wa.me/212${tel.slice(1)}`}
                    target="_blank"
                    rel="noreferrer noopener"
                    style={{
                      color: "#25D366",
                      paddingLeft: "0.3rem",
                      fontSize: "1.2rem",
                      background: "white",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      aspectRatio: "1/1",
                      borderRadius: "50%",
                      padding: "0.3rem"
                    }}
                  >
                    <RiWhatsappFill />
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default Table;
